import { Helmet } from "react-helmet";
import Breadcrumb from "../components/Breadcrumb";
import classes from "./ShippingPolicy.module.css";
import { Link } from "react-router-dom";

export default function ShippingPolicy() {
  return (
    <>
      <Helmet>
        <title>
          Shipping Policy - Server Stock UK Delivery Methods and Timelines
        </title>
        <meta
          name="description"
          content="Explore Server Stock UK's Shipping Policy. Learn about delivery times, cut-off schedules, DHL shipping, handling of missing or damaged items, and fast UK-wide delivery for IT products."
        />
        <link
          rel="canonical"
          href="https://www.serverstock.co.uk/shipping-policy"
        />
      </Helmet>

      <Breadcrumb currentPage="Shipping Policy" />
      <div className={`container ${classes.shippingPolicyContainer}`}>
        <p className={classes.paragraph}>
          All orders are processed within 1-2 business days (Monday to Friday).
        </p>

        <h3 className={classes.subheading}>Shipping time and charges:</h3>

        <table border="1" cellpadding="8" cellspacing="0">
          <thead>
            <tr>
              <th>Destination</th>
              <th>Shipping Time</th>
              <th>Shipping Fee</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>United Kingdom</td>
              <td>3–4 Business Days</td>
              <td>FREE Ground Shipping in UK</td>
            </tr>
          </tbody>
        </table>

        <h3 className={classes.subheading}>Who will deliver my order?</h3>

        <p className={classes.paragraph}>
          We rely on a network of external shipping partners around the world
          including the long-haul capabilities of DHL, UPS, and FedEx.
        </p>
        <p className={classes.paragraph}>Track the number for every order.</p>

        <h3 className={classes.subheading}>How can I track my order?</h3>

        <p className={classes.paragraph}>
          If you want to check the delivery status of your order, you can find
          the most updated tracking information by visiting Order History. Click
          on "Where's my package?" to view your order’s estimated date of
          arrival and tracking history.
        </p>

        <h3 className={classes.subheading}>
          Order changes and Product Specifications
        </h3>

        <p className={classes.paragraph}>
          Once your order has been confirmed, it cannot be modified or canceled.
          If you wish to return a product, you’ve outlined the returns procedure
          once you’ve received the item. Please note that items are ship
          according to their weight, i.e., charged according to their weight.
        </p>

        <h3 className={classes.subheading}>Received Damaged Product</h3>

        <p className={classes.paragraph}>
          It is important that customers report any shortages or damages in
          writing within 3 days of receiving their order. The report should
          include detailed descriptions of the issue. Once we receive the
          report, we will investigate and, if necessary, arrange for replacement
          or compensation. If the customer fails to report the issue within this
          period, they waive any related claims.
        </p>

        <h3 className={classes.subheading}>New</h3>

        <p className={classes.paragraph}>
          The item is New and in its original packaging.
        </p>

        <h3 className={classes.subheading}>New Bulk</h3>

        <p className={classes.paragraph}>
          Item was originally bulk packaged and then repackaged for individual
          sale.
        </p>

        <h3 className={classes.subheading}>New Pulls</h3>

        <p className={classes.paragraph}>
          Item was originally installed in a new system that was meant to be
          upgraded before we removed it and repackaged it in our own packing for
          individual sale.
        </p>

        <h3 className={classes.subheading}>Refurbished</h3>

        <p className={classes.paragraph}>
          Item was removed from a used system, refurbished, and tested to make
          it fully functional.
        </p>

        <h3 className={classes.subheading}>Used</h3>

        <p className={classes.paragraph}>
          Item was used. We have tested and re-packaged it for sale.
        </p>

        <h3 className={classes.subheading}>Item not received</h3>

        <p className={classes.paragraph}>
          If you've successfully placed an order and haven't received it yet the
          tracking status shows it's delivered. you'd wish to contact the
          carrier to hunt out your Bags as once the item is bagged we have
          control over it (once it’s by the carrier), but if still persists
          kindly email us at{" "}
          <Link to="mailto:support@serverstock.co.uk">
            support@serverstock.co.uk
          </Link>{" "}
        </p>

        <h3 className={classes.subheading}>
          How do I change my shipping address?
        </h3>
        <p className={classes.paragraph}>
          Before placing your order, you can change the shipping address
          directly in your shopping cart. If your order was placed within the
          first 12 hours, you can email us to change your " Shipping Address".
          Once your order has shipped, it's no longer possible to change the
          address. If you have any questions about shipping information, feel
          free to contact us. We are ready to provide the best services to you.
        </p>

        <h2 className={classes.mainHeading}>
          CLICK HERE TO CONTACT US DIRECTLY!
        </h2>
        <h3 className={classes.subheading}>For more information</h3>

        <p className={classes.paragraph}>
          <strong>Address: </strong> Unit #5, The Hub, A53-61 College Road,
          Harrow, HA1 1AR
        </p>

        <p className={classes.paragraph}>
          <strong>Email: </strong>{" "}
          <Link to="mailto:sales@serverstock.co.uk">
            sales@serverstock.co.uk
          </Link>{" "}
        </p>
        <p className={classes.paragraph}>
          <strong>Phone: </strong>{" "}
          <Link to="tel:+442475420877">+44 247 542 0877</Link>{" "}
        </p>

        <p className={classes.paragraph}>
          <strong>Working Hours: </strong> Mon - Fri / 8:00 AM - 5:00 PM (GMT)
        </p>
      </div>
    </>
  );
}
